if (!customElements.get('product-features')) {
  customElements.define(
    'product-features',
    class ProductFeatures extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('click', (e) => {
          const clickedElement = e.target.closest('[data-action]');
          if (!clickedElement) return;
          
          const {
            action,
            tabTarget,
            tempTarget
          } = clickedElement.dataset;

          switch (action) {
            case 'tab':
              [...this.querySelectorAll('[data-tab-target]')].forEach(btn => {
                const isSelected = btn.dataset.tabTarget === tabTarget;
                btn.classList.toggle('selected', isSelected);
                btn.setAttribute('aria-selected', isSelected);
              });
              [...this.querySelectorAll('[data-tab-content]')].forEach(panel => {
                const isVisible = panel.dataset.tabContent === tabTarget;
                panel.style.display = isVisible ? '' : 'none';
              });
              break;

            case 'temp':
              [...this.querySelectorAll('[data-temp-target]')].forEach(btn => {
                const isSelected = btn.dataset.tempTarget === tempTarget;
                btn.classList.toggle('selected', isSelected);
                btn.setAttribute('aria-selected', isSelected);
              });
              [...this.querySelectorAll('[data-temp-content]')].forEach(panel => {
                const isVisible = panel.dataset.tempContent === tempTarget;
                panel.style.display = isVisible ? '' : 'none';
              });
              break;
          }
        });
      }
    }
  );
}
